import { FC } from 'react';
import { FieldText } from '../field-text';
import { SearchIcon } from '../icons';
import { ISearchFilterProps } from './search-filter.types';

export const SearchFilter: FC<ISearchFilterProps> = ({
  onFilter,
  ...props
}) => {
  return (
    <FieldText
      {...props}
      icon={<SearchIcon />}
      onChange={e => onFilter(e.target.value)}
    />
  );
};
